import { type TransformerConfig } from '../common/types';
import { createDecodeFromDbFn, createEncodeToDbFn } from '../common/utils';
import { DBLegacyExamTypeSchema, LegacyExamTypeSchema } from './schemas';

export const LegacyExamTypeCodecConfig: TransformerConfig<
  typeof LegacyExamTypeSchema,
  typeof DBLegacyExamTypeSchema
> = {
  name: 'LegacyExamType',
  clientSchema: LegacyExamTypeSchema,
  dbSchema: DBLegacyExamTypeSchema,
  transformers: [],
};

export const encodeLegacyExamTypeToDb = createEncodeToDbFn(LegacyExamTypeCodecConfig);
export const decodeLegacyExamTypeFromDb = createDecodeFromDbFn(LegacyExamTypeCodecConfig);
